import { FOUNDER } from "@/data/founder";

/**
 * Handwritten signature element. Inline "— Maria" styled in Caveat with a soft sage ink stroke.
 * Props:
 *  - prefix: optional prefix line above signature ("with care," by default)
 *  - size: 'sm' | 'md' | 'lg'
 *  - align: 'left' | 'center'
 */
export default function Signature({
  prefix = "with care,",
  size = "md",
  align = "left",
  testId = "signature",
}) {
  const sizes = {
    sm: "text-3xl",
    md: "text-5xl",
    lg: "text-6xl",
  };
  return (
    <div
      data-testid={testId}
      className={`inline-flex flex-col ${align === "center" ? "items-center" : "items-start"}`}
    >
      <span className="text-xs uppercase tracking-[0.22em] text-[var(--cc-text-soft)]">
        {prefix}
      </span>
      <span
        className={`mt-2 ${sizes[size]} text-[var(--cc-primary)] leading-none`}
        style={{ fontFamily: "'Caveat', cursive", fontWeight: 500 }}
      >
        — {FOUNDER.name}
      </span>
      <svg
        className="mt-1 text-[var(--cc-primary)]/40"
        width="120"
        height="10"
        viewBox="0 0 120 10"
        fill="none"
        aria-hidden
      >
        <path
          d="M2 6 C 20 1, 45 9, 70 4 S 110 8, 118 3"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    </div>
  );
}
